@if (isCurrentUserWestnetzUser) {
    <mat-card class="westnetz-info-card">
        <mat-card-title>
            Westnetz-Info-Box
        </mat-card-title>
        <mat-card-content>
            <p>Bezeichnung der aktiven Datenabfrage: {{ dashboardInfoDTO.aktiveDatenAbfrage?.bezeichnung }}</p>
            <p>Anzahl Aufteilungsschlüssel der aktiven DatenAbfrage: {{ dashboardInfoDTO.aufteilungsschluesselCount }}</p>
            <p>Anzahl Erzeugungsanlagen: {{ dashboardInfoDTO.erzeugungsAnlagenCount }}</p>
            <p>Anzahl Netzzuordnungen: {{ dashboardInfoDTO.netzzuordnungCount }}</p>
        </mat-card-content>
    </mat-card>
} @else {
  <div fxLayout="column" fxLayoutAlign="space-around stretch" fxLayoutGap="1rem">
    @if (netzbetreiberService.shouldDisplayErzeugerDetails(dashboardInfoDTO)) {
      <mat-card (click)="openRoute('/erzeugungsanlage/list')"
        fxLayout="row" style="cursor: pointer">
        <img mat-card-sm-image src="/assets/eon-pictograms/smart_market.svg"/>
        <div fxLayout="column" fxLayoutAlign="space-around stretch">
          <mat-card-title style="font-size: 1.5rem">Erzeugungsanlagenliste
            ({{dashboardInfoDTO.erzeugungsAnlagenCount}})
          </mat-card-title>
          <mat-card-content style="font-size: 1.0rem">
            @if (dashboardInfoDTO.erzeugungsAnlageLastUpdateDate) {
              <span
                >
                Die letzte Änderung an Ihren Erzeugungsanlagen haben Sie
                am {{dashboardInfoDTO.erzeugungsAnlageLastUpdateDate | date:'dd.MM.yyyy'}}
                um {{dashboardInfoDTO.erzeugungsAnlageLastUpdateDate | date:'HH:mm'}} Uhr vorgenommen.
              </span>
            } @else {
              Noch keine Erzeugungsanlagenpflege erfolgt.
            }
            Zuletzt bestätigt ohne vorherige Änderungen hat Ihre Organisation <br/>
            am {{dashboardInfoDTO.netzbetreiberLastUpdate | date:'dd.MM.yyyy'}}
            um {{dashboardInfoDTO.netzbetreiberLastUpdate | date:'HH:mm'}} Uhr
          </mat-card-content>
        </div>
      </mat-card>
    }
    <mat-card (click)="openRoute('/netzzuordnung/list')" fxLayout="row" style="cursor: pointer">
      <img mat-card-sm-image src="/assets/eon-pictograms/digitalisation.svg">
      <div fxLayout="column" fxLayoutAlign="space-around stretch">
        <mat-card-title style="font-size: 1.5rem">Netzzuordnungsliste ({{dashboardInfoDTO.netzzuordnungCount}})
        </mat-card-title>
        <mat-card-content style="font-size: 1.0rem">
          Ihre letzte Bestätigung der UUIDs war
          am {{dashboardInfoDTO.lastConfirmedUuidDate | date:'dd.MM.yyyy'}}
          um {{dashboardInfoDTO.lastConfirmedUuidDate | date:'HH:mm'}} Uhr
        </mat-card-content>
      </div>
    </mat-card>
  </div>
}
